import append from 'ramda/src/append'

export default {
  /**
   * Sets the open flag on the state.
   *
   * @param {Object} state
   * @param {Boolean} open
   */
  SET_OPEN(state, open) {
    state.open = open
  },

  /**
   * Sets the images on the state.
   *
   * @param {Object} state
   * @param {Array} images
   */
  SET_IMAGES(state, images) {
    state.images = images
  },

  /**
   * Adds a single image to the state.
   *
   * @param {Object} state
   * @param {Object} image
   */
  ADD_IMAGE(state, image) {
    state.images = append(image, state.images)
  },
}
